import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface LastSyncedLabelProps {
  isoTimestamp: string | null | undefined;
  isLoading?: boolean;
}

function formatSyncTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

const LastSyncedLabel: React.FC<LastSyncedLabelProps> = ({ isoTimestamp, isLoading }) => {
  if (isLoading) {
    return <Skeleton variant="text" width={200} height={18} />;
  }
  if (!isoTimestamp) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <AccessTimeIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
      <Typography variant="caption" color="text.secondary">
        Last synced: {formatSyncTime(isoTimestamp)}
      </Typography>
    </Box>
  );
};

export default LastSyncedLabel;
